// ================== Service file ==================
// ProjectBoardServices/BoardModalAPI/LeftModalAPI/TitleBlockTabAPI.js

import { axiosInstance } from "../../../Services";

// ✅ Submit Title Block API
export const submitTitleBlock = async (inventoryId, titleBlockContent) => {
  try {
    const formData = new FormData();
    formData.append("title_block", titleBlockContent);

    const res = await axiosInstance.post(
      `/rsform/inventories/titleBlock/${inventoryId}`,
      formData,
      {
        headers: {
          "x-api-key": `${localStorage.getItem('token')}`,
        },
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// ✅ Fetch Title Block API (Optional)
export const fetchTitleBlock = async (inventoryId) => {
  try {
    const res = await axiosInstance.get(
      `/rsform/inventories/titleBlock/${inventoryId}`,
      {
        headers: {
          "x-api-key": `${localStorage.getItem('token')}`,
        },
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};
